/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './ReviewConfirmation.module.scss'
import { screenLoadingAction } from 'redux/actions'
import DebtInformationListTable from '../../DebtInformationList/components/DebinformationListTable'
import ContactInformationSummary from './ContactInformationSummary'
import MailingAddressSummary from './MailingAddressSummary'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { useLocation } from 'react-router'
import BackAnchor from 'shared/components/BackAnchor'
import { useHistory } from 'react-router-dom'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const [loading, setLoading] = useState(false)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)
  const [errMsg] = useState('')
  const dispatch = useDispatch()

  const userIdentifier = useSelector((state) => state.register.uniqueID)
  const { email } = useSelector((state) => state.app.contactInformation)
  const { payeeContactInformation, debtInformationList, contactInformation, mailingAddress } = useSelector((state) => state.app)
  // const { jointlyRegistered, nsHealthCard, registeredBusiness, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  // useEffect(() => {
  //   try {
  //     if (!fullName || !masterNumber) {
  //       // history.push(`/${i18n.language}${t('routes.your_info')}`)
  //     }
  //     else {
  //       console.log("TODO: FILL")
  //       // dispatch(editFromConfirmationAction(false));
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const fulfillmentStatus = params.get('fulfillmentStatus')
    if (fulfillmentStatus === 'SENTFORPAYMENT') {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      const businessData = {
        payeeContactInformation,
        debtInformationList,
        contactInformation,
        mailingAddress,
      }

      const data = {
        businessData: JSON.stringify(businessData),
        businessServiceType: 'PAYACOLLECTIONDEBT',
        lang: i18n.language.toString(),
        useridentifier: userIdentifier.toString(),
      }
      return data
    } catch (err) {
      dispatch(screenLoadingAction())
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    try {
      if (confirmChecked && !loading) {
        setLoading(true)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            dispatch(screenLoadingAction())
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setIsError('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  // const backNextProps = {
  //   prevText: t('review_confirmation.back'),
  //   prevURL: `/${i18n.language}${t('routes.contact_info')}`,
  //   nextText: t('review_confirmation.proceed_to_payment'),
  // }

  const emailStr = useMemo(() => {
    return payeeContactInformation ? t('review_confirmation.email_sent_plural') : t('review_confirmation.email_sent')
  }, [payeeContactInformation, t])

  const addAnotherDebt = () => {
    localStorage.setItem('addAnotherDebtClicked', 'reviewConfirm')
    history.push(`/${i18n.language}${t('routes.vehicle_tax_debt')}`)
  }

  return (
    <div>
      <div className="container">
        <div className="row">
          <BackAnchor />
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-8">
            <h1>{t('review_confirmation.title')}</h1>
          </div>
        </div>
        {fulfillmentStatusError && (
          <div className="row">
            <div className="col-xs-12 col-md-8" style={{ display: 'flex' }}>
              <i
                className={['fa fa-exclamation-circle fa-2x', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
                aria-hidden="true"
              />
              <div className={styles['error_message']} style={{ marginLeft: '1rem' }}>
                <div className="form-group has-error">
                  <div>
                    <h3 className="help-block">{t(fulfillmentStatusError)}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <DebtInformationListTable setIsError={setIsError} isSummary={true} />
            <button
              className={['btn-lg btn-default-transparent add-debt-button', styles['add-debt-button-1']].join(' ')}
              onClick={addAnotherDebt}
            >
              {t('review_confirmation.add_another_debt')}
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <ContactInformationSummary />
          </div>
        </div>
        {mailingAddress.isMailingAddress && (
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <MailingAddressSummary />
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <h3>{t('review_confirmation.confirmation')}</h3>
            {t('review_confirmation.please_verify')}
            <br />
            {t('review_confirmation.your_confirmation')}
            <ul style={{ marginTop: '2px' }}>
              <li>{t('review_confirmation.you_consent_to')}</li>
              <li>
                {t('review_confirmation.you_are_in_agreement')}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    i18n.language === 'en'
                      ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                      : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                  }
                >
                  {t('review_confirmation.terms_of_use')}
                </a>
                {t('review_confirmation.for_this_transaction')}
                <br />
                {/* <strong>{t('review_confirmation.note')}</strong>
                {t('review_confirmation.note_details')} */}
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-lg-12">
            <div className="ns-checkboxes__item">
              <input
                className="ns-checkboxes__input"
                type="checkbox"
                id="ConfirmationCheckBox"
                value="confirm_check"
                onChange={(e) => {
                  setConfirmChecked(e.currentTarget.checked)
                }}
                onBlur={() => {
                  confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
                }}
                checked={confirmChecked}
              />
              <label className="ns-label ns-checkboxes__label confirm_check_input" htmlFor="ConfirmationCheckBox">
                <span className="ns-label-span" style={{ paddingTop: '2px', left: '-10px' }}>
                  <b>{t('review_confirmation.yes_information_is_correct')}</b>
                </span>
              </label>
            </div>
            {checkboxMessage && (
              <div className="form-group has-error help-block">
                <i
                  style={{ margin: '3px 5px 0 0' }}
                  className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')}
                  aria-hidden="true"
                ></i>
                {t('review_confirmation.confirm_check_error')}
              </div>
            )}
          </div>
        </div>
        <button style={{ margin: '20px auto' }} className="btn-lg btn-success" onClick={confirmationClick} disabled={loading}>
          {t('review_confirmation.proceed_to_payment')}
        </button>
        {errMsg !== '' && (
          <div className={styles['error_message']}>
            <div className="form-group has-error">
              <div className="help-block">
                <i
                  className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
                  aria-hidden="true"
                />{' '}
                {t(errMsg)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
